import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cf32980"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__print-button" }
const _hoisted_2 = { class: "button-container print--hide" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-content" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "frontend-icon fi-printer" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "button-label" }, "Drucken")
], -1))

import { recProps } from 'vue/applications/frontend/mixins/rec-component';
  import SimpleButton from "vue/applications/frontend/components/simple-button.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-print-button',
  props: {...recProps()},
  setup(__props) {

  

  const print = () => {
    var textareas = document.querySelectorAll('textarea');
    textareas.forEach(function(textarea) {
      var textareaContent = document.createElement('p');
      textareaContent.className = "tmp--print"
      textareaContent.style.border = "solid grey 1px"
      textareaContent.style.padding = "10px"
      textareaContent.style.margin = "15px"
      textareaContent.style.minHeight = "40px"
      textareaContent.textContent = textarea.value;
      textarea.after(textareaContent);
      textarea.style.display = "none"
    });

    // we use custom appearance of checkboxes
    // since this not displayed correctly when printing, use the standard appearance
    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function(checkbox) {
      checkbox.style.appearance = "auto";
    });

    // when printing black-white, the difference between selected and unselected bubbles is very hard to recognize
    // => underline the selected bubble
    var selectedBubbles = document.querySelectorAll('.bubble-is-selected');
    selectedBubbles.forEach(function(bubble) {
      bubble.style.textDecoration = 'underline 2px';
    });

    window.print();

    // undo changes
    document.querySelectorAll('.tmp--print').forEach(e => e.remove());
    textareas.forEach(function(textarea) {
      textarea.style.display = "block"
    });

    checkboxes.forEach(function(checkbox) {
      checkbox.style.appearance = "none";
    });

    selectedBubbles.forEach(function(bubble) {
      bubble.style.textDecoration = "none";
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SimpleButton, {
        filled: "",
        class: "button-a button-a--small print-button",
        "use-theming": "",
        onMainAction: print
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ]))
}
}

})